// Types
import type { FC } from "react";

// Base
import { CountryDropdown } from "react-country-region-selector";

// Store
import { useProductData } from "@/zustand/productStore";

// Assets
import { DropdownArrow } from "@/assets/Icons";

interface CountryFieldProps {
  value?: string;
  error?: string;
  name: string;
  handleChange: (value: string) => void;
  placeholder?: string;
  contrast?: boolean;
}

const CountryField: FC<CountryFieldProps> = ({
  value,
  error,
  name,
  handleChange,
  placeholder,
  contrast,
}) => {
  const { country_code } = useProductData();

  if (!country_code) return null;

  const currentValue = value?.toUpperCase() || country_code;

  return (
    <div className="flex flex-col gap-1">
      <label
        className={`text-sm font-bold whitespace-nowrap ${
          contrast ? "text-cc-dark-gray" : "text-cc-gray"
        }`}
        htmlFor={name}
      >
        {placeholder}
      </label>
      <div className="relative">
        <CountryDropdown
          id="country"
          valueType="short"
          labelType="full"
          value={currentValue}
          name={name}
          autoComplete="country-name"
          className={`w-full appearance-none rounded-md border p-4 text-sm ${
            contrast ? "border-cc-gray-5" : "border-cc-gray-4"
          }`}
          style={{
            color: contrast ? "#333333" : "#0A0A0A",
          }}
          onChange={(val: string) => handleChange(val)}
        />

        <div className="pointer-events-none absolute top-1/2 right-4 flex -translate-y-1/2 items-center">
          <DropdownArrow />
        </div>
      </div>

      {error && <div className="mt-1 text-xs text-red-500">{error}</div>}
    </div>
  );
};

export default CountryField;
